import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyDashboardsDeleteRoute: InvariantJiraRoute = {
	name: 'legacy-dashboards-delete',
	path: '(/secure/|/)DeletePortalPage([!%]?[\\w]*).jspa',
};
